import type { ReactNode } from 'react';
import classes from './centered-screen.module.css';

interface CenteredScreenProps {
  /** Paints the brand gradient behind the content. Used by sign-in. */
  gradient?: boolean;
  children: ReactNode;
}

/**
 * A full-viewport centred surface.
 *
 * Sign-in, the session-check loader and the not-found page all need the same
 * thing, and all three had their own copy of `<Center h="100dvh">` with
 * slightly different padding.
 */
export function CenteredScreen({ gradient = false, children }: CenteredScreenProps) {
  const className = gradient
    ? `${classes.screen} ${classes.gradient}`
    : classes.screen;

  return (
    <div className={className}>
      <div className={classes.content}>{children}</div>
    </div>
  );
}
